export default "__VITE_ASSET__dvZLHPbt__"